/* old logic
export const getBottomGapX = (state) => {
  if (window.innerWidth < 1024) {
    return (425 - 5 * 39) / 6;
  }
  if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
    if (state) {
      return (439 - 5 * 39) / 6;
    } else {
      return (576 - 5 * 49) / 6;
    }
  }
  if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
    if (state) {
      return (590 - 5 * 50) / 6;
    } else {
      return (723 - 5 * 69) / 6;
    }
  }
  if (window.innerWidth >= 1920) {
    if (state) {
      return (768 - 5 * 70) / 6;
    } else {
      return (909 - 5 * 89) / 6;
    }
  }
}
export const getCoordinates = () => {
  const elem = document.querySelector('.adding');
  const answer = document.querySelector('.answer');
  const x1 = elem.getBoundingClientRect().x;
  const y1 = elem.getBoundingClientRect().y;
  const x2 = answer.getBoundingClientRect().x;
  const y2 = answer.getBoundingClientRect().y;
  const xDistance = x1 - x2;
  const yDistance = y1 - y2;
  return [
    xDistance - (answer.getBoundingClientRect().width - elem.getBoundingClientRect().width) / 2,
    yDistance - (answer.getBoundingClientRect().height - elem.getBoundingClientRect().height) / 2
  ];
}
export const getResult = () => {
  return [">", "<", "="].sort(() => Math.random() - 0.5);
}

export const getActions = () => {
  const first = Math.random() < 0.5 ? "*" : "/";
  const second = first === "*" ? "/" : "*";

  return [first, second];
}

const getNumbersArray = (number, action, level) => {
  if (action === "*") {
    const divisors = [];
    for (let i = 1; i <= number; i++) {
        if (number % i === 0) {
            divisors.push(i);
        }
    }
    const num =
        divisors[Math.floor(Math.random() * divisors.length)];
    return [num, number / num];
}
  if (action === "/") {
      const max = level === "beginner" ? 5 : level === "advanced" ? 20 : 15;
      const min = 1;
      const num = Math.floor(Math.random() * (max - min + 1) + min);
      return [number * num, num];
  }
}
export const getNumbers = (result, actions, level) => {
  if (result === "=") {
      const max = level === "beginner" ? 25 : level === "advanced" ? 400 : 225;
      const min = level === "beginner" ? 5 : level === "advanced" ? 20 : 15;
      const number = Math.floor(Math.random() * (max - min + 1) + min);
      const leftArray = getNumbersArray(number, actions[0], level);
      const rightArray = getNumbersArray(number, actions[1], level);
      return [...leftArray, ...rightArray];
  }
  else {
      const max1 = 50;
      const min1 = 10;
      const firstNumber = Math.floor(Math.random() * (max1 - min1 + 1) + min1);
      const max2 = firstNumber - 1;
      const min2 = 2;
      const secondNumber = Math.floor(Math.random() * (max2 - min2 + 1) + min2);
      if (result === ">") {
          const leftArray = getNumbersArray(firstNumber, actions[0], level);
          const rightArray = getNumbersArray(secondNumber, actions[1], level);
          return [...leftArray, ...rightArray];
      }
      if (result === "<") {
          const leftArray = getNumbersArray(secondNumber, actions[0], level);
          const rightArray = getNumbersArray(firstNumber, actions[1], level);
          return [...leftArray, ...rightArray];
      }
  }
}
export const getAnswer = () => {
  const max = 0;
  const min = 3;
  return Math.floor(Math.random() * (max - min + 1) + min);
}
export const getAnswers = (number, level) => {
  const max = level === "beginner" ? 50 : level === "advanced" ? 200 : 100;
  const min = level === "beginner" ? 10 : level === "advanced" ? 100 : 50;
  const array = new Set();
  array.add(number);
  while (array.size < 5) {
      array.add(
          Math.floor(Math.random() * (max - min + 1) + min)
      );
  }
  return Array.from(array).sort(() => Math.random() - 0.5);
}
export const getRightAnswerArray = (
  numbers,
  answers,
  index,
  operator,
  actions
) => {

  if (operator === "=") {
      return [numbers[index]];
  }

  const arr = [];

  answers.forEach((answer) => {
      const copyNumbers = [...numbers];
      copyNumbers[index] = answer;

      const left =
          actions[0] === "*"
              ? copyNumbers[0] * copyNumbers[1]
              : copyNumbers[0] / copyNumbers[1];

      const right =
          actions[1] === "*"
              ? copyNumbers[2] * copyNumbers[3]
              : copyNumbers[2] / copyNumbers[3];

      if (operator === ">" && left > right) {
          arr.push(answer);
      }

      if (operator === "<" && left < right) {
          arr.push(answer);
      }
  });

  return arr;
}
*/


export const getBottomGapX = (state) => {
  if (window.innerWidth<440) {
    return (240-5*39)/6;
  }
    if (window.innerWidth>=440 && window.innerWidth<736) {
    return (290-5*39)/6;
  }
  if (window.innerWidth>=736 && window.innerWidth<1024) {
    return (425-5*39)/6;
  }
  if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
    if (state) {
      return (439 - 5 * 39) / 6;
    } else {
      return (576 - 5 * 49) / 6;
    }
  }
  if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
    if (state) {
      return (590 - 5 * 50) / 6;
    } else {
      return (723 - 5 * 69) / 6;
    }
  }
  if (window.innerWidth >= 1920) {
    if (state) {
      return (768 - 5 * 70) / 6;
    } else {
      return (909 - 5 * 89) / 6;
    }
  }
}
export const getCoordinates = () => {
  const elem = document.querySelector('.adding');
  const answer = document.querySelector('.answer');
  const x1 = elem.getBoundingClientRect().x;
  const y1 = elem.getBoundingClientRect().y;
  const x2 = answer.getBoundingClientRect().x;
  const y2 = answer.getBoundingClientRect().y;
  const xDistance = x1 - x2;
  const yDistance = y1 - y2;
  return [
    xDistance - (answer.getBoundingClientRect().width - elem.getBoundingClientRect().width) / 2,
    yDistance - (answer.getBoundingClientRect().height - elem.getBoundingClientRect().height) / 2
  ];
}
export const getResult = () => {
  return [">", "<", "="].sort(() => Math.random() - 0.5);
};

export const getActions = () => {
  const first = Math.random() < 0.5 ? "*" : "/";
  const second = first === "*" ? "/" : "*";

  return [first, second];
};

const random = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const getNumbersArray = (action, level) => {
  const max =
    level === "beginner"
      ? 5
      : level === "advanced"
      ? 20
      : 10;

  const first = random(1, max);
  const second = random(1, max);

  if (action === "*") {
    return {
      numbers: [first, second],
      result: first * second,
    };
  }

  return {
    numbers: [first * second, second],
    result: first,
  };
};

export const getNumbers = (result, actions, level) => {
  let left;
  let right;

  do {
    left = getNumbersArray(actions[0], level);
    right = getNumbersArray(actions[1], level);
  } while (
    (result === ">" && !(left.result > right.result)) ||
    (result === "<" && !(left.result < right.result)) ||
    (result === "=" && !(left.result === right.result))
  );

  return [...left.numbers, ...right.numbers];
};

export const getAnswer = () => {
  return Math.floor(Math.random() * 4);
};

export const getAnswers = (number, level) => {
  const max =
    level === "beginner"
      ? 25
      : level === "advanced"
      ? 200
      : 100;

  const min =
    level === "beginner"
      ? 10
      : level === "advanced"
      ? 100
      : 50;

  const array = new Set();

  array.add(number);

  while (array.size < 5) {
    array.add(random(min, max));
  }

  return Array.from(array).sort(() => Math.random() - 0.5);
};

export const getRightAnswerArray = (
  numbers,
  answers,
  index,
  operator,
  actions
) => {
  if (operator === "=") {
    return [numbers[index]];
  }

  const arr = [];

  answers.forEach((answer) => {
    const copyNumbers = [...numbers];

    copyNumbers[index] = answer;

    const left =
      actions[0] === "*"
        ? copyNumbers[0] * copyNumbers[1]
        : copyNumbers[0] / copyNumbers[1];

    const right =
      actions[1] === "*"
        ? copyNumbers[2] * copyNumbers[3]
        : copyNumbers[2] / copyNumbers[3];

    if (operator === ">" && left > right) {
      arr.push(answer);
    }

    if (operator === "<" && left < right) {
      arr.push(answer);
    }
  });

  return arr;
};